<template>
    <el-row :gutter="30" class="mw-100">
        <el-col :lg="24" :xs="24">
            <div class="mb-20 d-flex ">
                <el-button type="primary" @click="handleAddPartner" class="ml-auto">
                    <!-- <font-awesome-icon :icon="['fas', 'user-plus']" style="width:20px" class="color-brown" /> -->
                    <span class="color-white">
                        add partner
                    </span>
                </el-button>
            </div>
            <el-card class="box-card">
                <el-table :data="partners" style="width: 100%">
                    
                    
                    <el-table-column label="" width="80" type="expand">
                        <template #default="props">
                            <h4> {{$getLocaleData(props.row.translates,'en_us').title}} Brands:</h4>
                            <el-row :gutter="30">
                                <el-col :lg="3" :xs="12" v-for="(brand, index) in props.row.subItems" :key="index">
                                        <el-card>
                                            <el-image 
                                                style="width: 100px; height: 100px" 
                                                :src="$getImage(brand.imageURL) || ''" 
                                                fit="cover"
                                                :zoom-rate="1.2"
                                                :preview-src-list="[$getImage(brand.imageURL)]"
                                                :preview-teleported="true"
                                            >
                                                <template #error>
                                                    <div class="image-slot">
                                                        <font-awesome-icon :icon="['fas', 'image']" />
                                                    </div>
                                                </template>
                                            </el-image>
                                        </el-card>
                                </el-col>
                            </el-row>
                        </template>
                    </el-table-column>
                    <el-table-column label="image" prop="imageURL" width="80" >
                        <template #default="scope">
                            <el-image 
                                style="width: 50px; height: 50px" 
                                :src="$getImage(scope.row.imageURL) || ''" 
                                fit="cover"
                                :zoom-rate="1.2"
                                :preview-src-list="[$getImage(scope.row.imageURL)]"
                                :preview-teleported="true"
                            >
                                <template #error>
                                    <div class="image-slot">
                                        <font-awesome-icon :icon="['fas', 'image']" />
                                    </div>
                                </template>
                            </el-image>
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="title En" >
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'en_us').title}}
                        </template>
                    </el-table-column>
                    <el-table-column label="description En" >
                        <template #default="scope">
                           <span v-html="$getLocaleData(scope.row.translates,'en_us').description"></span>
                        </template>
                    </el-table-column>

                    <el-table-column label="title Ar" class-name="text-right rtl">
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'ar_sa').title}}
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="description Ar" class-name="text-right rtl">
                        <template #default="scope">
                           <span v-html="$getLocaleData(scope.row.translates,'ar_sa').description"></span>
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="Operations" width="100">
                        <template #default="scope">
                            <el-tooltip
                                class="box-item"
                                effect="dark"
                                content="edit product"
                                placement="top"
                            >
                                <font-awesome-icon :icon="['fas', 'edit']" style="width:20px" @click="handleEditPartner(scope.row)" class="cursor-pointer" />
                            </el-tooltip>
                             
                                
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="status" width="100">
                        <template #default="scope">
                            <el-popconfirm 
                                title="Are you sure to change this product status?"
                                @confirm="changePartnerStatus(scope.row)"
                                @cancel="scope.row.status = !scope.row.status "
                            >
                                <template #reference>
                                    <el-switch
                                        v-model="scope.row.status"
                                        class="mb-2"
                                    />
                                </template>
                            </el-popconfirm>
                            
                        </template>
                    </el-table-column> -->
                    <el-table-column label="status" width="100">
                        <template #default="scope">
                            <el-popconfirm 
                                title="Are you sure to change this partner status?"
                                @confirm="changePartnerStatus(scope.row)"
                                @cancel="false"
                            >
                                <template #reference>
                                    <el-switch
                                        v-model="scope.row.active"
                                        class="mb-2"
                                    />
                                </template>
                            </el-popconfirm>
                            
                        </template>
                    </el-table-column>
                </el-table>
               
            </el-card>
        </el-col>
    </el-row>
 
</template>
<script>
export default {
    computed:{
        cachedPartners(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website.partners?.list || []
        },
    },
    data(){
        return{
            partners:[],
            partnerStatus:[],
           
        }
    },
    async mounted(){
        if (!this.cachedPartners?.length){
            this.getAllPartners();
        }else{
            this.partners = this.cachedPartners;
          
        }
        
       
    },
    
    methods:{
       
        async getAllPartners(){
            const response = await this.$store.dispatch('getAllPartners');

            this.partners = response;
             
        },
        async changePartnerStatus(partner){
            const response = await this.$store.dispatch('changePartnerStatus',partner.id);
            if (response.data.status == 1){
         
                this.getAllPartners();
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                });
            }else{
                let currentPartnerIndex = this.partners.findIndex(prt => prt.id == partner.id);
                this.partners[currentPartnerIndex].active = !this.partners[currentPartnerIndex].active 
                // this.partners.splice(currentPartnerIndex,1);
            }
             
        },
        async handleAddPartner(){
            this.$router.push({
                name:'manage-partner',
            })
           
        },
        async handleEditPartner(partner){
            await this.$store.dispatch('storeCurrentPartnerToView',partner)
            this.$router.push({
                name:'manage-partner',
                params:{
                    id:partner.id
                }
            })
        },
      
    
       
        
    }
}
</script>
<style lang="scss">
    .text-right.rtl {
        .cell {
            text-align: right;
            direction: rtl;
        }
    }
</style>